import React, { useId } from 'react';
interface TextFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'prefix'> {
  label: string;
  value: string;
  onChange: (value: string) => void;
  hint?: string;
  error?: string;
  prefix?: string;
  suffix?: string;
  optional?: boolean;
}
export function TextField({
  label,
  value,
  onChange,
  hint,
  error,
  prefix,
  suffix,
  optional,
  className = '',
  ...rest
}: TextFieldProps) {
  const id = useId();
  return <div className={className} data-id="element-715" data-mp="i7zfpn277ha">
      <label htmlFor={id} className="mb-1.5 flex items-baseline justify-between text-sm font-medium text-ink-700" data-id="element-716" data-mp="3rq2ltqsl19h9">
        {label}
        {optional && <span className="text-xs font-normal text-ink-400" data-id="element-717" data-mp="3ms0yuus1cq0i">Optional</span>}
      </label>
      <div className={`flex h-12 items-center rounded-xl bg-white px-3.5 ring-1 ring-inset transition-[box-shadow] duration-150 focus-within:ring-2 focus-within:ring-pulse-600 md:h-[52px] ${error ? 'ring-critical-500' : 'ring-ink-200 hover:ring-ink-300'}`} data-id="element-718" data-mp="3ir8p80f94j3p">
        {prefix && <span className="mr-1.5 text-ink-400" data-id="element-719" data-mp="1bkeir11a8pfw">{prefix}</span>}
        <input id={id} value={value} onChange={e => onChange(e.target.value)} aria-invalid={!!error} aria-describedby={hint || error ? `${id}-hint` : undefined} className="h-full w-full min-w-0 bg-transparent text-base text-ink-900 placeholder:text-ink-400 focus:outline-none" {...rest} data-id="element-720" data-mp="1gllrb2b91snm" />
        {suffix && <span className="ml-1.5 whitespace-nowrap text-sm text-ink-400" data-id="element-721" data-mp="1zbk5m05n4hzp">{suffix}</span>}
      </div>
      {(hint || error) && <p id={`${id}-hint`} className={`mt-1.5 text-[13px] ${error ? 'text-critical-700' : 'text-ink-500'}`} data-id="element-722" data-mp="1lkyke4sprvyn">
          {error ?? hint}
        </p>}
    </div>;
}